import React from 'react';
import { connect } from 'react-redux';
import { ContentWrapper, Wrapper } from './MainLayout.s';
import { createPureComponent, PathUtils } from 'module/Common';
import { Helmet } from 'react-helmet';
import { LangTopBar } from '../LangTopBar';
import { MainSelector } from 'module/Redux/Main';
import { Menu } from 'module/View/Menu';
import { MenuAction, MenuSelector } from 'module/Redux/Menu';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { Router } from '../Router';
import { RouterSelector } from 'module/Redux/Router';
import { Sizes, TouchDetect, WindowSizeProvider } from 'module/View/Common';
import { State } from 'module/Redux';

type StateProps = {
  menuOpen: boolean;
  lang: PathUtils.Lang;
  touch: boolean;
  touchDetected: boolean;
};

const mapStateToProps = (s: State): StateProps => ({
  menuOpen: MenuSelector.isOpen(s),
  lang: RouterSelector.selectLang(s),
  touch: MainSelector.isTouch(s),
  touchDetected: MainSelector.isTouchDetected(s),
});

type DispatchProps = {
  closeMenu: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  closeMenu: () => dispatch(MenuAction.setClose()),
});

type OwnProps = {
  adminBar: boolean;
};

type Props = StateProps & DispatchProps & OwnProps;

const MainLayoutComp = createPureComponent<Props>(
  'MainLayout',
  ({ closeMenu, menuOpen, adminBar, lang, touch, touchDetected }) => {
    return (
      <WindowSizeProvider>
        {({ width, height }) => {
          const contentWidth = Sizes.getContentWidth(width);
          const htmlNoScroll = Sizes.getMenuLayout(width) === Sizes.MenuLayout.Mobile && menuOpen;
          return (
            <TouchDetect>
              <Wrapper
                adminBar={adminBar}
                onClick={() => {
                  if (menuOpen) {
                    // closeMenu();
                  }
                }}
              >
                <Helmet>
                  <html lang={lang} style={(htmlNoScroll ? 'overflow: hidden;' : '') as any} />
                  <title>Atelier Beau / Voir</title>
                </Helmet>
                <Menu adminBarHeight={adminBar ? Sizes.getAdminBarHeght(width) : 0} />
                <ContentWrapper
                  margins={Sizes.getContentMargins(width)}
                  width={contentWidth}
                  onClick={() => {
                    if (menuOpen) {
                      closeMenu();
                    }
                  }}
                >
                  {Sizes.isLangTopBarVisible(width) && <LangTopBar />}
                  <Router adminBar={adminBar} availableWidth={contentWidth} />
                </ContentWrapper>
              </Wrapper>
            </TouchDetect>
          );
        }}
      </WindowSizeProvider>
    );
  }
);

export const MainLayout = connect(mapStateToProps, mapDispatchToProps)(MainLayoutComp);



// WEBPACK FOOTER //
// ./src/module/View/Main/MainLayout/MainLayout.tsx